import React, { useEffect, useState } from "react";
import { Grid, TextField, Button, MenuItem, Typography } from "@mui/material";
import { DelieveryNoteRo, vRdxUserInfo } from "../../../Redux/roStore";
import {
  SalesInvoice001_shipmentAddress,
  SalesInvoice001_shipmentGetRow,
  SalesInvoice001_SubKontenAddress_Detail_GetRow,
} from "../../../Server/ApiV2";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../../Utility/Utilitys";

function ShippingAddressForm({
  vocType = "",
  vocNo = "",
  vocTypeName = "",
  sDetailDispatchDrpdown = [],
}) {
  const [formData, setFormData] = useState({
    deliveryAddress: sDetailDispatchDrpdown[0]?.UId,
    name: "",
    contact: "",
    mobile: "",
    phone: "",
    fax: "",
    email: "",
    address1: "",
    address2: "",
    address3: "",
    city: "",
    country: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));

    if (name == "deliveryAddress") {
      fDependencyAddress(value);
    }
  };

  const handleSubmit = async (e) => {
    console.log(formData);
    let obj = {
      v_A_VocTyp: vocType,
      v_A_VocNo: vocNo,
      v_A_DAName: formData.name,
      v_A_DAContact: formData.contact,
      v_A_DAMobile: formData.mobile,
      v_A_DAPhone: formData.phone,
      v_A_DAFax: formData.fax,
      v_A_DAEMail: formData.email,
      v_A_DAAdd1: formData.address1,
      v_A_DAAdd2: formData.address2,
      v_A_DAAdd3: formData.address3,
      v_A_DACity: formData.city,
      v_A_DACountry: formData.country,
    };
    let resp = await SalesInvoice001_shipmentAddress(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (resp?.status === 200) {
      console.log(resp);
      fAlertToast("SUCCESS", "Delivery address updated successfully ");
      // handleClear();
      GetRow()
    } else {
      if (resp.response.status == 500) {
        fAlertToast(
          "FAILED",
          resp.response.data.message.msg ||
            "error in ValidateInvTransHeadUpdate "
        );
      }
    }
  };

  const handleClear = () => {
    setFormData({
      deliveryAddress: sDetailDispatchDrpdown[0]?.UId,
      name: "",
      contact: "",
      mobile: "",
      phone: "",
      fax: "",
      email: "",
      address1: "",
      address2: "",
      address3: "",
      city: "",
      country: "",
    });
  };

  const fDependencyAddress = async (value) => {
    const { HeadObject } = DelieveryNoteRo();

    let obj = {
      AcCd: HeadObject.A_Party,
      AddressType: value,
    };
    let resp = await SalesInvoice001_SubKontenAddress_Detail_GetRow(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (resp?.status === 200) {
      console.log(resp);
      if(resp?.data?.ResultSet?.length>0) {
        let respData = resp?.data?.ResultSet[0];
        setFormData((prevFormData) => ({
          ...prevFormData,
          name: respData?.Name,
          contact: respData?.Contact,
          mobile: respData?.Mobile,
          phone: respData?.Phone,
          fax: respData?.Fax,
          email: respData?.EMail,
          address1: respData?.Address1,
          address2: respData?.Address2,
          address3: respData?.Address3,
          city: respData?.City,
          country: respData?.Country,
        }));
      }else{
        handleClear()
      }
    
    } else {
      if (resp.response.status == 500) {
        fAlertToast(
          "FAILED",
          resp.response.data.message.msg ||
            "error in ValidateInvTransHeadUpdate "
        );
      }
    }
  };
  // INV08A_DELIVERY_ADRRESS_GetRow

// useEffect((() => {
//     fDependencyAddress(sDetailDispatchDrpdown[0]?.UId)
// }),[])
const GetRow=async()=>{
  const { HeadObject } = DelieveryNoteRo();
  let obj = { 
    v_A_VocTyp: HeadObject.A_VocTyp,
    v_A_VocNo: HeadObject.A_VocNo,
  };
   
  let resp = await SalesInvoice001_shipmentGetRow(
    fcheck_null_undefine_replace_empty(obj)
  );
  if (resp?.status === 200) {
    console.log(resp);
    if( resp?.data?.ResultSet.length > 0 ) {
      let respData = resp?.data?.ResultSet[0];     
  
      setFormData((prevFormData)=>({
        ...prevFormData, 
        name: respData.A_DAName,
        contact: respData.A_DAContact,
        mobile: respData.A_DAMobile,
        phone: respData.A_DAPhone,
        fax: respData.A_DAFax,
        email: respData.A_DAEMail,
        address1: respData.A_DAAdd1,
        address2: respData.A_DAAdd2,
        address3: respData.A_DAAdd3,
        city: respData.A_DACity,
        country: respData.A_DACountry,
      }))
    }
   
  } else {
    if (resp.response.status == 500) {
      fAlertToast(
        "FAILED",
        resp.response.data.message.msg ||
          "error in ValidateInvTransHeadUpdate "
      );
    }
  }
}


useEffect(() => {
  GetRow()
},[])
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={3}>
            <Typography sx={{ color: "var(--primary)" }}>
              Delivery Address:
            </Typography>
          </Grid>
          <Grid item xs={9}>
            <TextField
              select
              fullWidth
              size="small"
              name="deliveryAddress"
              value={formData.deliveryAddress}
              onChange={handleChange}
            >
              {sDetailDispatchDrpdown.map((address) => (
                <MenuItem key={address.UId} value={address.UId}>
                  {address.Name1}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={6}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={3}>
            <Typography sx={{ color: "var(--primary)" }}>Name:</Typography>
          </Grid>
          <Grid item xs={9}>
            <TextField
              fullWidth
              size="small"
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={3}>
            <Typography sx={{ color: "var(--primary)" }}>Contact:</Typography>
          </Grid>
          <Grid item xs={9}>
            <TextField
              fullWidth
              size="small"
              name="contact"
              value={formData.contact}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={6}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={3}>
            <Typography sx={{ color: "var(--primary)" }}>Mobile:</Typography>
          </Grid>
          <Grid item xs={9}>
            <TextField
              fullWidth
              size="small"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={3}>
            <Typography sx={{ color: "var(--primary)" }}>Phone:</Typography>
          </Grid>
          <Grid item xs={9}>
            <TextField
              fullWidth
              size="small"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={6}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={3}>
            <Typography sx={{ color: "var(--primary)" }}>Fax:</Typography>
          </Grid>
          <Grid item xs={9}>
            <TextField
              fullWidth
              size="small"
              name="fax"
              value={formData.fax}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={3}>
            <Typography sx={{ color: "var(--primary)" }}>Email:</Typography>
          </Grid>
          <Grid item xs={9}>
            <TextField
              fullWidth
              size="small"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={6}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={3}>
            <Typography sx={{ color: "var(--primary)" }}>Address 1:</Typography>
          </Grid>
          <Grid item xs={9}>
            <TextField
              fullWidth
              size="small"
              name="address1"
              value={formData.address1}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={3}>
            <Typography sx={{ color: "var(--primary)" }}>Address 2:</Typography>
          </Grid>
          <Grid item xs={9}>
            <TextField
              fullWidth
              size="small"
              name="address2"
              value={formData.address2}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={6}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={3}>
            <Typography sx={{ color: "var(--primary)" }}>Address 3:</Typography>
          </Grid>
          <Grid item xs={9}>
            <TextField
              fullWidth
              size="small"
              name="address3"
              value={formData.address3}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={3}>
            <Typography sx={{ color: "var(--primary)" }}>City:</Typography>
          </Grid>
          <Grid item xs={9}>
            <TextField
              fullWidth
              size="small"
              name="city"
              value={formData.city}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={1.5}>
            <Typography sx={{ color: "var(--primary)" }}>Country:</Typography>
          </Grid>
          <Grid item xs={10.5}>
            <TextField
              fullWidth
              size="small"
              name="country"
              value={formData.country}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} container justifyContent="center" spacing={2}>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleSubmit}
          >
            Save
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleClear}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default ShippingAddressForm;
